:host {
  display: block;
}

form {
  display: flex;
  flex-direction: column;
}

label {
  color: rgb(84, 84, 84);
  font-size: 16px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0.2px;
  line-height: 24px;
}

input {
  width: 100%;
  height: 48px;
  border: 1px solid rgb(168, 168, 168);
  border-radius: 0px;
  color: rgb(38, 38, 38);
  font-size: 20px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 30px;
}

select {
  width: 100%;
  color: rgb(38, 38, 38);
  font-size: 20px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 30px;
  height: 48px;
  border: 1px solid rgb(168, 168, 168);
  border-radius: 0px;
}

option {
  color: rgb(38, 38, 38);
  font-size: 20px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 30px;
}

option:hover {
  background-color: #2e5276;
}
